import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext, useEffect } from 'react';
import { DropdownField } from '../../../subcomponents/form/field/dropdown/dropdown-field';
import { getFieldClassName, getFieldId } from '../../../subcomponents/form/field/utils/field-attribute-utils';
import { QuickNavigatorContextInstance } from '../types/context';
import { QuickNavigatorActionType as ActionType } from '../utils/action-type';
export var DropdownType;
(function (DropdownType) {
    DropdownType["Site"] = "site";
    DropdownType["Film"] = "film";
    DropdownType["ScreeningDate"] = "screeningDate";
    DropdownType["Showtime"] = "showtime";
})(DropdownType || (DropdownType = {}));
const b = bemClassBuilder('v-quick-navigator-dropdown');
export const QuickNavigatorDropdown = observer(props => {
    const { options, errorMessageHelpText, loading, type, label, disabled, noSearchResultsFoundMessage, placeholder } = props;
    const { config, assets, state, dispatch } = useContext(QuickNavigatorContextInstance);
    const dropdownSelection = state.dropdownSelections[type];
    const handleDropdownSelectionChange = (value) => {
        dispatch({
            type: ActionType.SetSelectedValue,
            dropdownType: type,
            selectedValue: value
        });
    };
    // If dropdown options have been loaded and the previously selected value is no longer within the options, then clearing the selected value.
    useEffect(() => {
        if (loading)
            return;
        const selectedOption = options.find(o => o.value === dropdownSelection);
        if (!selectedOption) {
            dispatch({ type: ActionType.SetSelectedValue, selectedValue: undefined, dropdownType: type });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);
    return (_jsx(DropdownField, Object.assign({}, props, { id: getFieldId(b, type), value: dropdownSelection, className: getFieldClassName(b, type), showLabel: config.dropdownLabel.show, disabled: disabled || loading, error: errorMessageHelpText, buttonLoadingIconName: assets.loadingDataIconName, showEmptyDropdown: true, displayText: {
            label,
            placeholder,
            noSearchResultsFoundMessage
        }, onChangeValue: handleDropdownSelectionChange })));
});
QuickNavigatorDropdown.displayName = 'QuickNavigatorDropdown';
//# sourceMappingURL=dropdown.js.map